// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3KQDA","footer":"ModalCreateQualiphyProcedure_footer__3KMQ5","additionData":"ModalCreateQualiphyProcedure_additionData__3Luoo"};